import Immutable from 'seamless-immutable'
import _ from 'lodash'
import * as classifiedActions from 'reduxBits/classified/actions'
import * as actions from './actions'

const initialState = Immutable.from({
  isSending: false,
  error: null,
  confirmationModalOpen: false,
  isReporting: false,
  lastReportAdId: null,
  lastReportId: null,
  formErrors: null,
  formData: null,
})

const reportAd = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.SAVE_FORM_DATA:
      return state.merge({
        formData: payload,
      })
    case actions.SET_REPORT_AD_VISIBILITY:
      return state.merge({
        isReporting: payload,
      })
    case actions.SET_CONFIRMATION_VISIBILITY:
      return state.merge({
        confirmationModalOpen: payload,
      })
    case actions.REQUEST_CREATE_REPORT_AD:
      return state.merge({
        isSending: true,
      })
    case actions.RECEIVE_CREATE_REPORT_AD:
      if (error) {
        let formErrors = null
        if (_.get(payload, 'textOrJson.error') === 'validation_error') {
          formErrors = _.reduce(
            payload.textOrJson.parameters,
            (result, value) => {
              _.set(result, value.parameterName, value.errorTranslated)
              return result
            },
            {},
          )
        }
        return state.merge({
          isSending: false,
          formErrors,
          error,
        })
      }
      return state.merge({
        confirmationModalOpen: true,
        isReporting: false,
        isSending: false,
        lastReportAdId: payload.adId,
        lastReportId: payload.id,
        formErrors: null,
        error: false,
      })
    case classifiedActions.RECEIVE_AD:
      return state.merge({
        ...initialState,
      })
    case '@@router/LOCATION_CHANGE':
      return state.merge({
        confirmationModalOpen: false,
        isReporting: false,
      })
    default:
      return state
  }
}

export default reportAd
